import { FC, useEffect } from 'react';

import { usePageTitle } from '@app/hooks/usePageTitle';
import useActions from '@app/store/hooks/useActions';
import { TWalletType } from '@entities/wallets';
import WalletsMonitoringPage from '@pages/wallets/monitoring';

type Props = {
  type?: TWalletType;
};

/**
 * Flat wallets page that reuses the legacy monitoring widget
 * but hides child wallets. Defaults to deposit type.
 */
const WalletsPage: FC<Props> = ({ type = 'deposit' }) => {
  const { setWalletType } = useActions();
  const titles: Record<TWalletType, string> = {
    deposit: 'Wallets',
    withdraw: 'Wallets',
    settlement: 'Wallets',
  };

  usePageTitle(titles[type]);

  useEffect(() => {
    setWalletType(type);
  }, [setWalletType, type]);

  return <WalletsMonitoringPage type={type} showChildren={false} />;
};

export default WalletsPage;
